import React from 'react';
// import PropTypes from 'prop-types';
import {
  Menu,
  Button,
  Dropdown /*Breadcrumb*/,
  // Form,
  // Input,
} from 'antd';
import styled from 'styled-components';

// import {
//   SearchOutlined,
// } from '@ant-design/icons';

const ProfileMenu = styled.div`
  position: absolute;
  height: 64px;
  line-height: 64px;
  right: 2rem;
  top: 0;
`;

const SearchMenu = styled.div`
  position: absolute;
  height: 64px;
  line-height: 64px;
  right: 5rem;
  top: 0;
`;

const HeaderMenu = ({user, onLogoutClick, onAccountSettingsClick}) => {

  const getNameAbbreviation = (name) => {
    const nameparts = name.split(' ');
    if(nameparts.length === 1) {
      return name.substr(0, 2).toUpperCase();
    }
    return nameparts.map(word => word.substr(0, 1)).join('').substr(0, 2).toUpperCase();
  }
  return (
    <div className="no-print">
      <SearchMenu>
        {/* <Form
          name="global-search"
          className="global-search-form"
          initialValues={{
            remember: true,
          }}
          style={{ display: 'inline-block' }}
        >
          <Form.Item
            name="username"
          >
            <Input
              prefix={<SearchOutlined className="site-form-item-icon" />}
              placeholder="Search"
            />
          </Form.Item>
        </Form> */}
      </SearchMenu>
      <ProfileMenu>
        <Dropdown
          trigger={['click']}
          overlay={
            <Menu style={{minWidth: '150px'}}>
              <Menu.Item key="0">{user.name}</Menu.Item>
              <Menu.Divider />
              {/* <Menu.Item key="1">Profile Page</Menu.Item> */}
              <Menu.Item key="2" onClick={onAccountSettingsClick}>Change Password</Menu.Item>
              {/* <Menu.Divider /> */}
              <Menu.Item key="3" onClick={onLogoutClick}>Logout</Menu.Item>
            </Menu>
          }
        >
          <Button
            type="primary"
            shape="circle"
            onClick={(e) => e.preventDefault()}
          >
            {user && getNameAbbreviation(user.name)}
          </Button>
        </Dropdown>
      </ProfileMenu>
    </div>
  );
};

HeaderMenu.defaultProps = {
};

HeaderMenu.propTypes = {
};

export default HeaderMenu;